/**
 * These are endpoints still in use in our legacy python backend api.
 * This is not a complete list, other usages still exist elsewhere; such as Live View and Chat functionality
 */

import * as api from "../js/api/api";

type Username = string;

export interface AddUserEvent {
	teacher: Username;
	classroomName: string;
	studentsAdded: Username[];
	studentsRemoved: Username[];
}

interface AddUserEventBody {
	time: number; // timestamp in seconds
	user: string; // teacher username
	group: string; // can be a classroom or group name
	users_added: string[]; // students added (usernames)
	users_removed: string[]; // students removed (usernames)
}

/**
 * Sends a classroom modified event to the backend.
 * This api call is intended to be done in the background without relying on success/failure.
 */
export const postClassroomModifiedEvent = (event: AddUserEvent): void => {
	const body: AddUserEventBody = {
		time: Date.now() / 1000,
		user: event.teacher,
		group: event.classroomName,
		users_added: event.studentsAdded,
		users_removed: event.studentsRemoved,
	};
	api.post("/backend/events/add/user", body);
};
